import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  href,
  className = '',
  onClick
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal/50';
  const variants = {
    primary: 'bg-teal text-white hover:bg-teal-dark shadow-lg hover:shadow-xl',
    secondary: 'bg-white text-teal border-2 border-teal hover:bg-cream'
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-167">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={onClick} data-id="element-168">
      {children}
    </motion.button>;
}